import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardTitle } from 'reactstrap';
import EditableDropdown from './EditableDropdown';
import HelpPopover from './HelpPopover';

export default class UserAccess extends React.PureComponent {
  // many people will proceed happyily without ever looking at this,
  // so let's lazily fetch relevant data
  componentDidMount() {
    if (!this.props.users || this.props.users.length === 0) {
      this.props.setUsers();
    }
  }

  render() {
    return (<Card>
      <CardBody>
        <CardTitle>
          Set Primary User&nbsp;&nbsp;
          <HelpPopover
            size="sm"
            name="primary-user-description"
            placement={'right'}
            title="Primary User Access"
          >
            This field is automatically set to the user who created the project
            and will appear in that user&rsquo;s &ldquo;Your Projects&rdquo; list. Users with
            freelancer or vendor status only have access to a project when listed as the
            primary user here. All regular organization users have access to
            all projects made within that organization.
          </HelpPopover>
        </CardTitle>
      </CardBody>
      <CardBody>
        <EditableDropdown
          name="user"
          title="Select a user"
          value={this.props.user}
          options={this.props.users}
          update={this.props.update}
        />
      </CardBody>
    </Card>);
  }
}

UserAccess.propTypes = {
  users: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  user: PropTypes.string,
  setUsers: PropTypes.func,
  update: PropTypes.func,
};
